import type { ISettingsMailbox } from 'features/SettingsOld/interfaces/ISettings'

export enum SETTINGS_ADD_CARD_CONSTANTS {
  NUMBER = 'Card number',
  EXPIRY_DATE = 'Expiry date (MM/YY)',
  CVC = 'Security Code (CVC)',
}

export enum SETTINGS_CONSTANTS {
  PAYMENT = 'Payment',
  ADD_CARD = 'Add Card',
  EDIT_CARD = 'Edit Card',
  NO_CARD_ADDED = 'No card added',
  PAYMENT_METHOD = 'Default payment method',
  BILLING_HISTORY = 'Billing History',
  PAYMENTS_HISTORY = 'Payments History',
  MAILBOX_PROFILE = 'Receive mail addressed to',
  ADD_ANOTHER_CARD = 'Add another card',
  INVOICE = 'invoice',
  ADD_A_NEW_CARD = 'Add a new card',
  NEED_ADD_CARD = 'You must add a valid credit card to book.',
}

export enum SettingsMailboxLabels {
  fullName = 'Full Name',
  company = 'Company',
  address = 'Address',
  city = 'City',
  state = 'State',
  signInTheBpx = 'Sign in the box',
  postalCode = 'Postal Code',
  messagingID = 'Text Messaging ID',
  toBeNotified = 'I want to be notified when I receive mail',
  mailNameAsCustomer = 'Mail name same as customer name',
  toBeNotifiedDescription = 'By providing a mobile telephone number or email address above, you consent that we can send to you text or email messages relating to your use of Mailbox.Your mobile carrier may impose charges to you as a result of such text or email messages. Message and rate may apply',
  emailAddress = 'Email address',
  businessTelephone = 'Business telephone',
  mobileTelephone = 'Mobile telephone',
  homeTelephone = 'Home telephone',
  fax = 'Fax',
  firmName = 'Firm Name',
  homePhone = 'Home Phone',
  businessPhone = 'Business phone',
  businessType = 'Business type',
  forwardingPhone = 'Forwarding phone',
  forwardingAddress = 'Forwarding address',
  initials = 'Initials',
  phoneNumber = 'Phone number',
}

export enum SettingsMailboxKeys {
  fullName = 'fullName',
  company = 'company',
  address = 'address',
  city = 'city',
  state = 'state',
  postalCode = 'postalCode',
  messagingID = 'messagingId',
  mailAsCustomer = 'mailAsCustomer',
  toBeNotified = 'toBeNotified',
  emailAddress = 'emailAddress',
  businessTelephone = 'businessTelephone',
  mobileTelephone = 'mobileTelephone',
  homeTelephone = 'homeTelephone',
  fax = 'fax',
}

export enum SETTINGS_BILLING_LABELS {
  STATE = 'State',
  ADDRESS = 'Address',
  COUNTRY = 'Country',
  FULL_NAME = 'Cardholder name',
  APARTMENT = 'Address (line 2)',
  CITY = 'City',
  ZIP_CODE = 'ZIP Code',
  BILLING_ADDRESS = 'Billing address',
}

export const INITIAL_MAILBOX_DATA: ISettingsMailbox = {
  mailAsCustomer: false,
  fullName: '',
  company: '',
  address: '',
  city: '',
  state: '',
  postalCode: '',
  messagingID: '',
  toBeNotified: false,
  emailAddress: '',
  businessTelephone: '',
  mobileTelephone: '',
  homeTelephone: '',
  fax: '',
}
